import * as Sentry from "@sentry/react";
import { AxiosError } from "axios";

class ErrorHandler extends Error {
	static logError(error: unknown) {
		if (
			(error instanceof AxiosError && error.code === "ERR_CANCELED") ||
			(error instanceof DOMException && error.name === "AbortError")
		) {
			return;
		}
		Sentry.captureException(error);

		if (error instanceof Error) {
			console.error("Error captured:", error.message);
		} else {
			console.error("Unknown error captured:", error);
		}
	}
}

export default ErrorHandler;
